import { GlobalOnexConfig } from '@onex/model'

export const config: GlobalOnexConfig = {
  active: false,
  id: 'E3332',
  smoketestsIncludeOnex: false,
  localE2eTestsIncludeOnex: false,
  activeOnexConfig: {
    StatusQuo: {
      template: 'cookieBanner-onetrust.html',
      styleFile: 'styles-onetrust--simple-cookie.scss',
    },
    NewConsB: {
      styleFile: 'styles-onetrust--newConsB-pc-button-grey.scss',
    },
    NewConsC: {
      styleFile:
        'styles-onetrust--newConsC-pc-button-grey-and-ok-button-in-the-middle.scss',
    },
    NewConsD: {
      styleFile: 'styles-onetrust--newConsD-ok-button-grey.scss',
    },
    NewConsE: {
      styleFile:
        'styles-onetrust--newConsE-ok-button-grey-and-in-the-middle.scss',
    },
  },
}
